import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Updates the cache after a successful update request.
 *
 * Behavior:
 * 1. If response data exists:
 *    - Updates cache entities with the response data
 * 2. If no response data:
 *    - Combines request data updates with existing cached entity
 *    - Ensures complete object persistence when updates are partial
 */
export const cacheUpdate = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.update.success.observe().pipe(
      rxjs.map(action =>
        plugin.collection.plugins.cachePlugin.feature.actions.put
          .from(action)
          .create({
            entities: action.data.response
              ? action.data.response
              : // TODO: this is a temporary solution, we need to find a better way to handle this
                action.data.request.map(request => ({
                  ...plugin.collection.plugins.cachePlugin.feature.selectors
                    .getCachedEntity(request.id)
                    .asSignal(),
                  ...request.updates,
                })),
          }),
      ),
    ),
)
